<template>
  <div class="registered">
    <div class="reg-box">
      <div class="title">
        <span class="personal pointer-hover" :class="[select == 'pe' ? 'active' : '']" @click="selectTap('pe')">个人注册</span>
        <span class="enterprise pointer-hover" :class="[select == 'qy' ? 'active' : '']" @click="selectTap('qy')">企业注册</span>
      </div>
      <div class="form-box">
        <template v-if="select == 'qy'">
          <div class="form-item">
            <div class="label">企业名称:</div>
            <div class="value">
              <input class="input" v-model="qy_name" placeholder="请输登入企业名称" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">统一社会信用代码:</div>
            <div class="value">
              <input class="input" v-model="credit_code" placeholder="请输统一社会信用代码" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">许可证编号:</div>
            <div class="value">
              <input class="input" v-model="license_number" placeholder="请输许可证编号" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">法人姓名:</div>
            <div class="value">
              <input class="input" v-model="per_user" placeholder="请输法人姓名" />
            </div>
          </div>
        </template>
        <div class="form-item" v-if="select == 'pe'">
          <div class="label">姓名:</div>
          <div class="value">
            <input class="input" v-model="user_name" placeholder="请输入证件上的姓名" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">证件类型:</div>
          <div class="value">
            <input class="input" type="text" value="身份证" placeholder="身份证" disabled />
          </div>
        </div>
        <div class="form-item">
          <div class="label">证件号码:</div>
          <div class="value">
            <input class="input" v-model="card_code" maxlength="18" @change="cardChange" placeholder="请输入证件号码" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">登陆用户名:</div>
          <div class="value">
            <input class="input" v-model="user" placeholder="请输登入用户名" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">密码:</div>
          <div class="value">
            <input class="input" type="password" v-model="pwd" placeholder="请输入用户密码" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">确认密码:</div>
          <div class="value">
            <input class="input" type="password" v-model="ag_pwd" placeholder="再次确认用户密码" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">邮箱:</div>
          <div class="value">
            <input class="input" v-model="emall" placeholder="请输入常用邮箱" />
          </div>
        </div>
      </div>
      <div class="reg-btn" @click="registerTap">注册</div>
    </div>
  </div>
</template>
<script>
import { validateIdent } from '@/assets/common';
export default {
  data() {
    return {
      user: '',
      pwd: '',
      ag_pwd: '',
      user_name: '',
      card_code: '',
      certificates: '',
      emall: '',
      select: 'pe',
      qy_name: '',
      credit_code: '',
      license_number: '',
      per_user: ''
    }
  },
  // 监听input输入框输入的值
  // watch: {
  //   // 手机号输入框
  //   card_code: {
  //     immediate: false,
  //     handler(val) {
  //       if (!!val) {
  //         this.cardChange(val);
  //       }
  //     }
  //   },
  // },
  //页面挂载完时执行
  mounted() {
    let that = this;
    that.$nextTick(() => {})
  },
  methods: {
    cardChange(e) {
      console.log(e);
    },
    selectTap(e) {
      this.select = e;
    },
    registerTap() {

      if (this.select == 'pe' && (!this.user || !this.pwd || !this.ag_pwd || !this.user_name || !this.card_code || !this.emall)) {
        this.warning('请认真填写所有内容');
        return;
      }
      if (this.select == 'qy' && (!this.qy_name || !this.credit_code || !this.license_number || !this.per_user)) {
        this.warning('请认真填写所有内容1');
        return;
      }
      if (!validateIdent.IdentityCodeValid(this.card_code)) {
        this.warning('请输入正确的身份证号码');
        return;
      }
      if (this.pwd != this.ag_pwd) {
        this.warning('两次输入的密码不一致');
        return;
      }
      if (this.pwd.length < 8) {
        this.warning('密码不得少于8位');
        return;
      }
      let emall_reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!emall_reg.test(this.emall)) {
        this.warning('请输入正确的邮箱');
        return;
      }

      this.$alert('注册信息审核中，审核结果将发送至您填写的邮箱，请耐心等待！', '提交成功', {
        confirmButtonText: '确定',
        callback: action => {
          this.$router.push({ name: 'index' })
        }
      });
    },
    warning(msg) {
      this.$message({
        message: msg,
        type: 'error'
      });
    }
  }
}

</script>
<style scoped>
.registered {
  display: flex;
  justify-content: center;
}
.reg-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 1200px;
  background: #fff;
  padding-bottom: 50px;
  padding-top: 50px;
  margin-top: 10px;
  min-height: 70vh;
  justify-content: flex-start;
}
.reg-box .title {
  font-size: 16px;
}
.reg-box .personal {
  position: relative;
  margin-right: 20px;
}
.reg-box .title .active {
  color: #3889fc;
}
.reg-box .personal:before {
  content: '';
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  height: 14px;
  border-right: 1px solid #aaa;

}
.form-box {
  width: 1200px;
}
.form-box .form-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.form-item .label {
  width: 40%;
  text-align: right;
  padding-right: 16px;
  color: #333;
  font-size: 14px;
}
.form-item .value input {
  border: none;
  width: 300px;
  height: 40px;
  font-size: 14px;
  padding-left: 6px;
  outline: none;
}
.form-item .value {
  border-bottom: 1px solid #eee;
}
.reg-btn {
  width: 300px;
  height: 40px;
  font-size: 16px;
  color: #fff;
  background: #3889fc;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/register.vue